import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { GamificationProfile } from '../types'

export const gamificationApi = {
  fetchProfile: () => apiClient.get<ApiResponse<GamificationProfile>>('/me/gamification'),
}
